import { CargoDoc } from './CargoDoc'
import { basicCacheKeys } from '@/utils/cacheConfig'
import { getSpecificBasicData } from '@/utils/basicDataCache'
import { cacheName, cache } from '@/utils/cacheManager'
import { getEdiContainerList } from '@/api/seaExport/seaCargoDoc'
import { updateProperties, completeTheFeed, getSeaCargoDoc, toInsure,
  getAfrAddressList, getCfmAddress, getSeaCargoDocByJobUuid, autoAuditSingleReleaseHBL } from '@/api/SeaImport/seaImCargoDoc'
import $store from '@/store'

import * as CargoDocConsts from '@/class/cargo/model/parameters/CargoDocConsts'
import { CargoDocUtil } from '@/class/cargo/model/utils/CargoDocUtil'
import ColumnUtils from '@/utils/ColumnUtils'
import LocalStorageUtilsNew from '@/utils/localStorageUtilsNew'

export class SeaImCargoDoc extends CargoDoc {
  /**
   * @param {Object} data
   */
  constructor(data) {
    super(data)
    this.className = 'SeaImCargoDoc'
  }

  // =====非db 字段
  get chkConsolidationClosed() {
    return this._data.chkConsolidationClosed
  }
  set chkConsolidationClosed(chkConsolidationClosed) {
    this._data.chkConsolidationClosed = chkConsolidationClosed || false
  }

  get mblNbr2() {
    return this._data.mblNbr2
  }
  set mblNbr2(mblNbr2) {
    this._data.mblNbr2 = mblNbr2
  }
  get subDocType2() {
    return this._data.subDocType2
  }
  set subDocType2(subDocType2) {
    this._data.subDocType2 = subDocType2
  }
  get quantitySum() {
    return this._data.quantitySum
  }
  set quantitySum(quantitySum) {
    this._data.quantitySum = quantitySum
  }
  get containerSum() {
    return this._data.containerSum
  }
  set containerSum(containerSum) {
    this._data.containerSum = containerSum
  }
  get loadingPort() {
    return this._data.loadingPort
  }
  set loadingPort(loadingPort) {
    this._data.loadingPort = loadingPort
  }
  get dischargingPort() {
    return this._data.dischargingPort
  }
  set dischargingPort(dischargingPort) {
    this._data.dischargingPort = dischargingPort
  }
  get destinationPort() {
    return this._data.destinationPort
  }
  set destinationPort(destinationPort) {
    this._data.destinationPort = destinationPort
  }
  get dispatchingPlace() {
    return this._data.dispatchingPlace
  }
  set dispatchingPlace(dispatchingPlace) {
    this._data.dispatchingPlace = dispatchingPlace
  }
  get destinationPlace() {
    return this._data.destinationPlace
  }
  set destinationPlace(destinationPlace) {
    this._data.destinationPlace = destinationPlace
  }
  get paymentPlaceBL() {
    return this._data.paymentPlaceBL
  }
  set paymentPlaceBL(paymentPlaceBL) {
    this._data.paymentPlaceBL = paymentPlaceBL
  }
  get edi() {
    return this._data.edi
  }
  set edi(edi) {
    this._data.edi = edi || false
  }
  get manifestEDI() {
    return this._data.manifestEDI
  }
  set manifestEDI(manifestEDI) {
    this._data.manifestEDI = manifestEDI || false
  }
  get remarks() {
    return this._data.remarks
  }
  set remarks(remarks) {
    this._data.remarks = remarks
  }
  get printParam1() {
    return this._data.printParam1
  }
  set printParam1(printParam1) {
    this._data.printParam1 = printParam1 || false
  }
  get printParam2() {
    return this._data.printParam2
  }
  set printParam2(printParam2) {
    this._data.printParam2 = printParam2 || false
  }
  get printParam3() {
    return this._data.printParam3
  }
  set printParam3(printParam3) {
    this._data.printParam3 = printParam3 || false
  }
  get printParam4() {
    return this._data.printParam4
  }
  set printParam4(printParam4) {
    this._data.printParam4 = printParam4
  }
  get printParam5() {
    return this._data.printParam5
  }
  set printParam5(printParam5) {
    this._data.printParam5 = printParam5
  }
  get printParam6() {
    return this._data.printParam6
  }
  set printParam6(printParam6) {
    this._data.printParam6 = printParam6 || false
  }
  get serialNo() {
    return this._data.serialNo
  }
  set serialNo(serialNo) {
    this._data.serialNo = serialNo
  }
  get seaeq() {
    return this._data.seaeq
  }
  set seaeq(seaeq) {
    this._data.seaeq = seaeq
  }
  get container() {
    return this._data.container
  }
  set container(container) {
    this._data.container = container
  }
  get alsoNotify() {
    return this._data.alsoNotify
  }
  set alsoNotify(alsoNotify) {
    this._data.alsoNotify = alsoNotify
  }
  get costcoNo() {
    return this._data.costcoNo
  }
  set costcoNo(costcoNo) {
    this._data.costcoNo = costcoNo
  }
  get cargoManifestName() {
    return this._data.cargoManifestName
  }
  set cargoManifestName(cargoManifestName) {
    this._data.cargoManifestName = cargoManifestName
  }
  get mblId() {
    return this._data.mblId
  }
  set mblId(mblId) {
    this._data.mblId = mblId
  }
  get shipperTel() {
    return this._data.shipperTel
  }
  set shipperTel(shipperTel) {
    this._data.shipperTel = shipperTel
  }
  get consigneeTel() {
    return this._data.consigneeTel
  }
  set consigneeTel(consigneeTel) {
    this._data.consigneeTel = consigneeTel
  }
  get notifyTel() {
    return this._data.notifyTel
  }
  set notifyTel(notifyTel) {
    this._data.notifyTel = notifyTel
  }
  get releaseReview() {
    return this._data.releaseReview
  }
  set releaseReview(releaseReview) {
    this._data.releaseReview = releaseReview || 0
  }
  get reviewDate() {
    return this._data.reviewDate
  }
  set reviewDate(reviewDate) {
    this._data.reviewDate = reviewDate
  }
  get releaseState() {
    return this._data.releaseState
  }
  set releaseState(releaseState) {
    this._data.releaseState = releaseState || 0
  }
  get releaseDate() {
    return this._data.releaseDate
  }
  set releaseDate(releaseDate) {
    this._data.releaseDate = releaseDate
  }
  get payable() {
    return this._data.payable
  }
  set payable(payable) {
    this._data.payable = payable || false
  }
  get agreePayDate() {
    return this._data.agreePayDate
  }
  set agreePayDate(agreePayDate) {
    this._data.agreePayDate = agreePayDate
  }
  get withhold() {
    return this._data.withhold
  }
  set withhold(withhold) {
    this._data.withhold = withhold || false
  }
  get withholdDate() {
    return this._data.withholdDate
  }
  set withholdDate(withholdDate) {
    this._data.withholdDate = withholdDate
  }
  get withholdReason() {
    return this._data.withholdReason
  }
  set withholdReason(withholdReason) {
    this._data.withholdReason = withholdReason
  }
  get secondReleaseDate() {
    return this._data.secondReleaseDate
  }
  set secondReleaseDate(secondReleaseDate) {
    this._data.secondReleaseDate = secondReleaseDate
  }
  get surrenderedApplicant() {
    return this._data.surrenderedApplicant
  }
  set surrenderedApplicant(surrenderedApplicant) {
    this._data.surrenderedApplicant = surrenderedApplicant || 0
  }
  get surrenderedApplicationDate() {
    return this._data.surrenderedApplicationDate
  }
  set surrenderedApplicationDate(surrenderedApplicationDate) {
    this._data.surrenderedApplicationDate = surrenderedApplicationDate
  }
  get surrenderedNo() {
    return this._data.surrenderedNo
  }
  set surrenderedNo(surrenderedNo) {
    this._data.surrenderedNo = surrenderedNo
  }
  get customerCfmException() {
    return this._data.customerCfmException
  }
  set customerCfmException(customerCfmException) {
    this._data.customerCfmException = customerCfmException
  }
  get originalBLWay() {
    return this._data.originalBLWay
  }
  set originalBLWay(originalBLWay) {
    this._data.originalBLWay = originalBLWay || 0
  }
  get warehouseNo() {
    return this._data.warehouseNo
  }
  set warehouseNo(warehouseNo) {
    this._data.warehouseNo = warehouseNo
  }
  get freightTermHBL() {
    return this._data.freightTermHBL
  }
  set freightTermHBL(freightTermHBL) {
    this._data.freightTermHBL = freightTermHBL
  }
  get shipperContact() {
    return this._data.shipperContact
  }
  set shipperContact(shipperContact) {
    this._data.shipperContact = shipperContact
  }
  get shipperMobile() {
    return this._data.shipperMobile
  }
  set shipperMobile(shipperMobile) {
    this._data.shipperMobile = shipperMobile
  }
  get shipperFax() {
    return this._data.shipperFax
  }
  set shipperFax(shipperFax) {
    this._data.shipperFax = shipperFax
  }
  get shipperEmail() {
    return this._data.shipperEmail
  }
  set shipperEmail(shipperEmail) {
    this._data.shipperEmail = shipperEmail
  }
  get shipperZipCode() {
    return this._data.shipperZipCode
  }
  set shipperZipCode(shipperZipCode) {
    this._data.shipperZipCode = shipperZipCode
  }
  get shipperCity() {
    return this._data.shipperCity
  }
  set shipperCity(shipperCity) {
    this._data.shipperCity = shipperCity
  }
  get consigneeContact() {
    return this._data.consigneeContact
  }
  set consigneeContact(consigneeContact) {
    this._data.consigneeContact = consigneeContact
  }
  get consigneeMobile() {
    return this._data.consigneeMobile
  }
  set consigneeMobile(consigneeMobile) {
    this._data.consigneeMobile = consigneeMobile
  }
  get consigneeFax() {
    return this._data.consigneeFax
  }
  set consigneeFax(consigneeFax) {
    this._data.consigneeFax = consigneeFax
  }
  get consigneeEmail() {
    return this._data.consigneeEmail
  }
  set consigneeEmail(consigneeEmail) {
    this._data.consigneeEmail = consigneeEmail
  }
  get consigneeZipCode() {
    return this._data.consigneeZipCode
  }
  set consigneeZipCode(consigneeZipCode) {
    this._data.consigneeZipCode = consigneeZipCode
  }
  get consigneeCity() {
    return this._data.consigneeCity
  }
  set consigneeCity(consigneeCity) {
    this._data.consigneeCity = consigneeCity
  }
  get notifyContact() {
    return this._data.notifyContact
  }
  set notifyContact(notifyContact) {
    this._data.notifyContact = notifyContact
  }
  get notifyMobile() {
    return this._data.notifyMobile
  }
  set notifyMobile(notifyMobile) {
    this._data.notifyMobile = notifyMobile
  }
  get notifyFax() {
    return this._data.notifyFax
  }
  set notifyFax(notifyFax) {
    this._data.notifyFax = notifyFax
  }
  get notifyEmail() {
    return this._data.notifyEmail
  }
  set notifyEmail(notifyEmail) {
    this._data.notifyEmail = notifyEmail
  }
  get notifyZipCode() {
    return this._data.notifyZipCode
  }
  set notifyZipCode(notifyZipCode) {
    this._data.notifyZipCode = notifyZipCode
  }
  get notifyCity() {
    return this._data.notifyCity
  }
  set notifyCity(notifyCity) {
    this._data.notifyCity = notifyCity
  }
  get alsoNotifyCode() {
    return this._data.alsoNotifyCode
  }
  set alsoNotifyCode(alsoNotifyCode) {
    this._data.alsoNotifyCode = alsoNotifyCode
  }
  get alsoNotifyLine1() {
    return this._data.alsoNotifyLine1
  }
  set alsoNotifyLine1(alsoNotifyLine1) {
    this._data.alsoNotifyLine1 = alsoNotifyLine1
  }
  get alsoNotifyLine2() {
    return this._data.alsoNotifyLine2
  }
  set alsoNotifyLine2(alsoNotifyLine2) {
    this._data.alsoNotifyLine2 = alsoNotifyLine2
  }
  get alsoNotifyLine3() {
    return this._data.alsoNotifyLine3
  }
  set alsoNotifyLine3(alsoNotifyLine3) {
    this._data.alsoNotifyLine3 = alsoNotifyLine3
  }
  get alsoNotifyLine4() {
    return this._data.alsoNotifyLine4
  }
  set alsoNotifyLine4(alsoNotifyLine4) {
    this._data.alsoNotifyLine4 = alsoNotifyLine4
  }
  get alsoNotifyLine5() {
    return this._data.alsoNotifyLine5
  }
  set alsoNotifyLine5(alsoNotifyLine5) {
    this._data.alsoNotifyLine5 = alsoNotifyLine5
  }
  get alsoNotifyLine6() {
    return this._data.alsoNotifyLine6
  }
  set alsoNotifyLine6(alsoNotifyLine6) {
    this._data.alsoNotifyLine6 = alsoNotifyLine6
  }
  get alsoNotifyLine7() {
    return this._data.alsoNotifyLine7
  }
  set alsoNotifyLine7(alsoNotifyLine7) {
    this._data.alsoNotifyLine7 = alsoNotifyLine7
  }
  get alsoNotifyContact() {
    return this._data.alsoNotifyContact
  }
  set alsoNotifyContact(alsoNotifyContact) {
    this._data.alsoNotifyContact = alsoNotifyContact
  }
  get alsoNotifyMobile() {
    return this._data.alsoNotifyMobile
  }
  set alsoNotifyMobile(alsoNotifyMobile) {
    this._data.alsoNotifyMobile = alsoNotifyMobile
  }
  get alsoNotifyFax() {
    return this._data.alsoNotifyFax
  }
  set alsoNotifyFax(alsoNotifyFax) {
    this._data.alsoNotifyFax = alsoNotifyFax
  }
  get alsoNotifyEmail() {
    return this._data.alsoNotifyEmail
  }
  set alsoNotifyEmail(alsoNotifyEmail) {
    this._data.alsoNotifyEmail = alsoNotifyEmail
  }
  get alsoNotifyZipCode() {
    return this._data.alsoNotifyZipCode
  }
  set alsoNotifyZipCode(alsoNotifyZipCode) {
    this._data.alsoNotifyZipCode = alsoNotifyZipCode
  }
  get alsoNotifyCity() {
    return this._data.alsoNotifyCity
  }
  set alsoNotifyCity(alsoNotifyCity) {
    this._data.alsoNotifyCity = alsoNotifyCity
  }
  get dgconsignCode() {
    return this._data.dgconsignCode
  }
  set dgconsignCode(dgconsignCode) {
    this._data.dgconsignCode = dgconsignCode
  }
  get dgconsignLine1() {
    return this._data.dgconsignLine1
  }
  set dgconsignLine1(dgconsignLine1) {
    this._data.dgconsignLine1 = dgconsignLine1
  }
  get dgconsignLine2() {
    return this._data.dgconsignLine2
  }
  set dgconsignLine2(dgconsignLine2) {
    this._data.dgconsignLine2 = dgconsignLine2
  }
  get dgconsignLine3() {
    return this._data.dgconsignLine3
  }
  set dgconsignLine3(dgconsignLine3) {
    this._data.dgconsignLine3 = dgconsignLine3
  }
  get dgconsignLine4() {
    return this._data.dgconsignLine4
  }
  set dgconsignLine4(dgconsignLine4) {
    this._data.dgconsignLine4 = dgconsignLine4
  }
  get dgconsignLine5() {
    return this._data.dgconsignLine5
  }
  set dgconsignLine5(dgconsignLine5) {
    this._data.dgconsignLine5 = dgconsignLine5
  }
  get dgconsignLine6() {
    return this._data.dgconsignLine6
  }
  set dgconsignLine6(dgconsignLine6) {
    this._data.dgconsignLine6 = dgconsignLine6
  }
  get dgconsignLine7() {
    return this._data.dgconsignLine7
  }
  set dgconsignLine7(dgconsignLine7) {
    this._data.dgconsignLine7 = dgconsignLine7
  }
  get dgconsignContact() {
    return this._data.dgconsignContact
  }
  set dgconsignContact(dgconsignContact) {
    this._data.dgconsignContact = dgconsignContact
  }
  get dgconsignMobile() {
    return this._data.dgconsignMobile
  }
  set dgconsignMobile(dgconsignMobile) {
    this._data.dgconsignMobile = dgconsignMobile
  }
  get dgconsignFax() {
    return this._data.dgconsignFax
  }
  set dgconsignFax(dgconsignFax) {
    this._data.dgconsignFax = dgconsignFax
  }
  get dgconsignEmail() {
    return this._data.dgconsignEmail
  }
  set dgconsignEmail(dgconsignEmail) {
    this._data.dgconsignEmail = dgconsignEmail
  }
  get dgconsignZipCode() {
    return this._data.dgconsignZipCode
  }
  set dgconsignZipCode(dgconsignZipCode) {
    this._data.dgconsignZipCode = dgconsignZipCode
  }
  get dgconsignCity() {
    return this._data.dgconsignCity
  }
  set dgconsignCity(dgconsignCity) {
    this._data.dgconsignCity = dgconsignCity
  }
  get elseInvoiceCode() {
    return this._data.elseInvoiceCode
  }
  set elseInvoiceCode(elseInvoiceCode) {
    this._data.elseInvoiceCode = elseInvoiceCode
  }
  get elseInvoiceLine1() {
    return this._data.elseInvoiceLine1
  }
  set elseInvoiceLine1(elseInvoiceLine1) {
    this._data.elseInvoiceLine1 = elseInvoiceLine1
  }
  get elseInvoiceLine2() {
    return this._data.elseInvoiceLine2
  }
  set elseInvoiceLine2(elseInvoiceLine2) {
    this._data.elseInvoiceLine2 = elseInvoiceLine2
  }
  get elseInvoiceLine3() {
    return this._data.elseInvoiceLine3
  }
  set elseInvoiceLine3(elseInvoiceLine3) {
    this._data.elseInvoiceLine3 = elseInvoiceLine3
  }
  get elseInvoiceLine4() {
    return this._data.elseInvoiceLine4
  }
  set elseInvoiceLine4(elseInvoiceLine4) {
    this._data.elseInvoiceLine4 = elseInvoiceLine4
  }
  get elseInvoiceLine5() {
    return this._data.elseInvoiceLine5
  }
  set elseInvoiceLine5(elseInvoiceLine5) {
    this._data.elseInvoiceLine5 = elseInvoiceLine5
  }
  get elseInvoiceLine6() {
    return this._data.elseInvoiceLine6
  }
  set elseInvoiceLine6(elseInvoiceLine6) {
    this._data.elseInvoiceLine6 = elseInvoiceLine6
  }
  get elseInvoiceLine7() {
    return this._data.elseInvoiceLine7
  }
  set elseInvoiceLine7(elseInvoiceLine7) {
    this._data.elseInvoiceLine7 = elseInvoiceLine7
  }
  get elseInvoiceContact() {
    return this._data.elseInvoiceContact
  }
  set elseInvoiceContact(elseInvoiceContact) {
    this._data.elseInvoiceContact = elseInvoiceContact
  }
  get elseInvoiceMobile() {
    return this._data.elseInvoiceMobile
  }
  set elseInvoiceMobile(elseInvoiceMobile) {
    this._data.elseInvoiceMobile = elseInvoiceMobile
  }
  get elseInvoiceFax() {
    return this._data.elseInvoiceFax
  }
  set elseInvoiceFax(elseInvoiceFax) {
    this._data.elseInvoiceFax = elseInvoiceFax
  }
  get elseInvoiceEmail() {
    return this._data.elseInvoiceEmail
  }
  set elseInvoiceEmail(elseInvoiceEmail) {
    this._data.elseInvoiceEmail = elseInvoiceEmail
  }
  get elseInvoiceZipCode() {
    return this._data.elseInvoiceZipCode
  }
  set elseInvoiceZipCode(elseInvoiceZipCode) {
    this._data.elseInvoiceZipCode = elseInvoiceZipCode
  }
  get elseInvoiceCity() {
    return this._data.elseInvoiceCity
  }
  set elseInvoiceCity(elseInvoiceCity) {
    this._data.elseInvoiceCity = elseInvoiceCity
  }
  get showPODAgency() {
    return this._data.showPODAgency
  }
  set showPODAgency(showPODAgency) {
    this._data.showPODAgency = showPODAgency
  }
  get receivedDate() {
    return this._data.receivedDate
  }
  set receivedDate(receivedDate) {
    this._data.receivedDate = receivedDate
  }
  get getBackDate() {
    return this._data.getBackDate
  }
  set getBackDate(getBackDate) {
    this._data.getBackDate = getBackDate
  }
  get claimDate() {
    return this._data.claimDate
  }
  set claimDate(claimDate) {
    this._data.claimDate = claimDate
  }
  get customerSelfRelease() {
    return this._data.customerSelfRelease
  }
  set customerSelfRelease(customerSelfRelease) {
    this._data.customerSelfRelease = customerSelfRelease || 0
  }
  get vessel() {
    return this._data.vessel
  }
  set vessel(vessel) {
    this._data.vessel = vessel
  }
  get voyageFlight() {
    return this._data.voyageFlight
  }
  set voyageFlight(voyageFlight) {
    this._data.voyageFlight = voyageFlight
  }
  get loadingPortCode() {
    return this._data.loadingPortCode
  }
  set loadingPortCode(loadingPortCode) {
    this._data.loadingPortCode = loadingPortCode
  }
  get dischargingPortCode() {
    return this._data.dischargingPortCode
  }
  set dischargingPortCode(dischargingPortCode) {
    this._data.dischargingPortCode = dischargingPortCode
  }
  get destinationPortCode() {
    return this._data.destinationPortCode
  }
  set destinationPortCode(destinationPortCode) {
    this._data.destinationPortCode = destinationPortCode
  }
  get vesselIMO() {
    return this._data.vesselIMO
  }
  set vesselIMO(vesselIMO) {
    this._data.vesselIMO = vesselIMO
  }
  get dispatchingPlaceCode() {
    return this._data.dispatchingPlaceCode
  }
  set dispatchingPlaceCode(dispatchingPlaceCode) {
    this._data.dispatchingPlaceCode = dispatchingPlaceCode
  }
  get vesselCode() {
    return this._data.vesselCode
  }
  set vesselCode(vesselCode) {
    this._data.vesselCode = vesselCode
  }
  get afrLast() {
    return this._data.afrLast
  }
  set afrLast(afrLast) {
    this._data.afrLast = afrLast || false
  }
  get seaImportJob() {
    return this._data.seaImportJob
  }
  set seaImportJob(seaImportJob) {
    this._data.seaImportJob = seaImportJob
  }
  get ediContainer() {
    return this._data.ediContainer
  }
  set ediContainer(ediContainer) {
    this._data.ediContainer = ediContainer
  }
  get afrAddress() {
    return this._data.afrAddress
  }
  set afrAddress(afrAddress) {
    this._data.afrAddress = afrAddress
  }
  get freightCharges() {
    return this._data.freightCharges
  }
  set freightCharges(freightCharges) {
    this._data.freightCharges = freightCharges
  }
  async getEdiContainer() {
    const data = this._data
    if (typeof data.ediContainer !== 'object') {
      if (data.uuid) {
        data.ediContainer = await getEdiContainerList({ cargoDocUuid: data.uuid }).then(res => res.data)
      } else {
        data.ediContainer = []
      }
    }
    return data.ediContainer
  }
  static newCargoDoc(model, docType) {
    const cargoDoc = new SeaImCargoDoc().fillDefaultValue().getData()
    cargoDoc.jobUuid = model.uuid
    cargoDoc.docType = docType
    cargoDoc.mark = model.mark
    cargoDoc.cargoEnglishName = model.cargoEnglishName
    if (docType === 'MBL' && !cargoDoc.notifyLine1) {
      cargoDoc.notifyLine1 = 'SAME AS CONSIGNEE'
    }
    this.copyInfoFromSeaImportJob(model, cargoDoc).then(r => {})
    return cargoDoc
  }
  static async copyInfoFromSeaImportJob(job, doc) {
    if (doc.state > 1) return
    const seaPorts = await getSpecificBasicData(basicCacheKeys.basic_data_Seaport)
    // 提单发货地，应该是seaopinput.placeOfReceipt
    doc.dispatchingPlace = job.dispatchingPlace
    // 提单起运港
    if (job.loadingPortCode) {
      const ports = seaPorts.filter(p => p.code === job.loadingPortCode)
      if (ports && ports.length > 0) {
        doc.loadingPort = ports[0].englishName
      }
    }
    // 提单卸货港
    if (job.dischargingPortCode) {
      const ports = seaPorts.filter(p => p.code === job.dischargingPortCode)
      if (ports && ports.length > 0) {
        doc.dischargingPort = ports[0].englishName
      }
    }
    // 提单目的港
    if (job.destinationPortCode) {
      const ports = seaPorts.filter(p => p.code === job.destinationPortCode)
      if (ports && ports.length > 0) {
        doc.destinationPort = ports[0].englishName
      }
    }
    if (doc.docType !== 'MBL' && doc.docType !== 'MBL2') {
      // 提单收货地
      doc.destinationPlace = job.destinationPlace
    }
    if (doc.docType === 'MBL' && job.masterFlag) {
      const office = $store.getters.currentOffice
      if (office) {
        doc.shipperLine1 = office.seaAddressLine1
        doc.shipperLine2 = office.seaAddressLine2
        doc.shipperLine3 = office.seaAddressLine3
        doc.shipperLine4 = office.seaAddressLine4
        doc.shipperLine5 = office.seaAddressLine5
        doc.shipperLine6 = office.seaAddressLine6
      }
    }
    await cache.load(cacheName.CONFIG)
    const config = cache.config
    // 通过参数BillOfLadingSynMode同步件毛体和包装
    CargoDocUtil.changeJobSynToBillOfLading(job, doc)
    // 根据参数判断是否同步小件数包装
    const isInsidePacking = Number(config.get('seaInsidePacking'))
    if (isInsidePacking === 1) {
      doc.insidePacking = job.insidePacking
    }
    // doc.issuerBL = 'UBI'
    ColumnUtils.customOrderFormTypeFunc(doc)
    // 新增时，如果已经选择提单方式，会重置为默认值
    if (doc.releaseType === 0) {
      const releaseType = Number(config.get('ReleaseTypeDefaultValue'))
      if (releaseType === 1) {
        doc.releaseType = 1
        doc.blNumber = 'THREE'
      } else if (releaseType === 2) {
        doc.releaseType = 3
        doc.blNumber = 'ONE'
      } else if (releaseType === 4) {
        let type
        if (doc.docType === 'MBL') {
          type = LocalStorageUtilsNew.getConfiguration('SI_MBL_BL_MODEL')
        } else if (doc.docType === 'HBL') {
          type = LocalStorageUtilsNew.getConfiguration('SI_HBL_BL_MODEL')
        }
        doc.releaseType = type || 1
        doc.BLNumber = 'ONE'
        if (doc.releaseType === 1) {
          doc.BLNumber = 'THREE'
        }
      }
    } else { // 重置提单份数
      if (doc.releaseType === 1) {
        doc.blNumber = 'THREE'
      } else {
        doc.blNumber = 'ONE'
      }
    }
    // doc.packing = job.packing
    doc.state = 1
  }
  static async copyInfoFromJobPort(job, doc) {
    if (doc.state > 1) {
      return
    }
    const seaPorts = await getSpecificBasicData(basicCacheKeys.basic_data_Seaport)
    // 提单发货地，应该是seaopinput.placeOfReceipt
    doc.dispatchingPlace = job.dispatchingPlace
    // 提单起运港
    if (job.loadingPortCode) {
      const ports = seaPorts.filter(p => p.code === job.loadingPortCode)
      if (ports && ports.length > 0) {
        doc.loadingPort = ports[0].englishName
      }
    }
    // 提单卸货港
    if (job.dischargingPortCode) {
      const ports = seaPorts.filter(p => p.code === job.dischargingPortCode)
      console.log('===bbb', ports)
      if (ports && ports.length > 0) {
        doc.dischargingPort = ports[0].englishName
      }
    }
    // 提单目的港
    if (job.destinationPortCode) {
      const ports = seaPorts.filter(p => p.code === job.destinationPortCode)
      if (ports && ports.length > 0) {
        doc.destinationPort = ports[0].englishName
      }
    }
    if (doc.docType !== 'MBL' && doc.docType !== 'MBL2') {
      // 提单收货地
      doc.destinationPlace = job.destinationPlace
    }
  }
  static async updateProperties(uuids, props) {
    return await updateProperties(props, uuids).then(res => res.data)
  }
  static async completeTheFeed(uuid, version) {
    return await completeTheFeed({ uuid, version }).then(res => res.data)
  }
  static async getSeaCargoDoc(uuid) {
    return await getSeaCargoDoc({ uuid }).then(res => res.data)
  }
  static async getSeaCargoDocByJobUuid(jobUuid) {
    return await getSeaCargoDocByJobUuid({ jobUuid }).then(res => res.data)
  }
  static async toInsure(companyName, seaCargoDoc, job, office) {
    return await toInsure({ companyName, seaCargoDoc, job, office }).then(res => res.data)
  }
  static async getCfmAddress(cargoDocUuid, version, tenantName, jobNo, officeId, inviterEmail) {
    return await getCfmAddress({ cargoDocUuid, version, tenantName, jobNo, officeId, inviterEmail }).then(res => res.data)
  }
  async getAfrAddress() {
    const data = this._data
    if (typeof data.afrAddress !== 'object') {
      if (data.uuid) {
        data.afrAddress = await getAfrAddressList({ cargoDocUuid: data.uuid }).then(res => res.data)
      } else {
        data.afrAddress = []
      }
    }
    return data.afrAddress
  }
  // 基本属性的复制
  copyBasic(source) {
    super.copyBasic(source)
    this.dispatchingPlace = source.dispatchingPlace
    this.loadingPort = source.loadingPort
    this.dischargingPort = source.dischargingPort
    this.destinationPort = source.destinationPort
    this.destinationPlace = source.destinationPlace
    this.paymentPlaceBL = source.paymentPlaceBL
    this.signPlaceBL = source.signPlaceBL
  }

  /**
   * 同步唛头 英文品名 包装
   * @param job
   */
  static async changeSynData(job, b = false, cargoDoc = null) {
    if (b) {
      const mdoc = await job.getMainMbl(false)
      if (mdoc != null) {
        this.changeJobSynToData(job, mdoc)
      }
      const hdoc = await job.getMainHbl(false)
      if (hdoc != null) {
        this.changeJobSynToData(job, hdoc)
      }
    } else {
      const billOfLadingSynMode = parseInt(cache.config.get('BillOfLadingSynMode'))
      if (billOfLadingSynMode === 2) {
        job.packing = cargoDoc.packing
      }

      const seaCargoEnglishName = parseInt(cache.config.get('seaCargoEnglishName'))
      if (seaCargoEnglishName === 2) {
        CargoDocUtil.changeBillOfLadingSynDoc(cargoDoc, job, ['cargoEnglishName'], true)
      }
      const seaCargoMark = parseInt(cache.config.get('seaCargoMark'))
      if (seaCargoMark === 2) {
        CargoDocUtil.changeBillOfLadingSynDoc(cargoDoc, job, ['mark'], true)
      }
    }
  }

  /**
   * Job同步至提单
   */
  static changeJobSynToData(job, cargoDoc) {
    if (job == null || cargoDoc == null) return
    const billOfLadingSynMode = parseInt(cache.config.get('BillOfLadingSynMode'))
    if (billOfLadingSynMode === 1 || billOfLadingSynMode === 2) {
      cargoDoc.packing = job.packing
    }
    if (cargoDoc.docType === CargoDocConsts.MBL || (cargoDoc.docType === CargoDocConsts.HBL && cargoDoc.state !== 2)) {
      const seaCargoEnglishName = parseInt(cache.config.get('seaCargoEnglishName'))
      if ([1, 2].indexOf(seaCargoEnglishName) > -1 || !job.uuid) {
        cargoDoc.cargoEnglishName = job.cargoEnglishName
        if (seaCargoEnglishName === 2) {
          CargoDocUtil.changeBillOfLadingSynDoc(cargoDoc, job, ['cargoEnglishName'])
        }
      }
      const seaCargoMark = parseInt(cache.config.get('seaCargoMark'))
      if ([1, 2].indexOf(seaCargoMark) > -1 || !job.uuid) {
        cargoDoc.mark = job.mark
        if (seaCargoMark === 2) {
          CargoDocUtil.changeBillOfLadingSynDoc(cargoDoc, job, ['mark'])
        }
      }
    }
  }

  /**
   * 同步 件毛体
   * @param job
   * @param quantityActual
   * @param weightActual
   * @param cubageActual
   */
  static async changeSynDataQWC(job, b = false, cargoDoc = null) {
    if (b) {
      var mdoc = await job.getMainMbl(false)
      if (mdoc != null) {
        this.changejobSynToBillOfLading2(job, mdoc)
      }
      var hdoc = await job.getMainHbl(false)
      if (hdoc != null) {
        this.changejobSynToBillOfLading2(job, hdoc)
      }
    } else {
      var billOfLadingSynMode = parseInt(cache.config.get('BillOfLadingSynMode'))
      if ([2, 4].includes(billOfLadingSynMode)) {
        job.quantityActual = cargoDoc.quantity
        job.weightActual = cargoDoc.weight
        job.cubageActual = cargoDoc.cubage
        job.chargeWeight = cargoDoc.chargeWeight
        if (billOfLadingSynMode !== 4) {
          job.packing = cargoDoc.packing
        }
        job.quantityContract = job.quantityActual
        job.weightContract = job.weightActual
        job.cubageContract = job.cubageActual
        CargoDocUtil.changeBillOfLadingSynDoc(cargoDoc, job, billOfLadingSynMode === 4 ? ['quantity', 'weight', 'cubage', 'chargeWeight'] : ['quantity', 'weight', 'cubage', 'chargeWeight', 'packing'])
      }
    }
  }

  /**
   * Job同步至提单
   */
  static changejobSynToBillOfLading2(job, cargoDoc) {
    if (job == null || cargoDoc == null) return
    var billOfLadingSynMode = parseInt(cache.config.get('BillOfLadingSynMode'))
    if ([1, 2, 3].includes(billOfLadingSynMode)) {
      if (cargoDoc.docType === CargoDocConsts.MBL || (cargoDoc.docType === CargoDocConsts.HBL && cargoDoc.state !== 2)) {
        cargoDoc.quantity = job.quantityActual
        cargoDoc.weight = job.weightActual
        cargoDoc.cubage = job.cubageActual
        cargoDoc.chargeWeight = job.chargeWeight
        if (billOfLadingSynMode !== 3) {
          cargoDoc.packing = job.packing
        }
      }
      if (billOfLadingSynMode === 2) {
        CargoDocUtil.changeBillOfLadingSynDoc(cargoDoc, job, ['quantity', 'weight', 'cubage', 'chargeWeight', 'packing'])
      }
    }
  }
  static async autoAuditSingleReleaseHBL(cargoDocUuid) {
    return await autoAuditSingleReleaseHBL({ cargoDocUuid })
  }
}
